// This is to be added as a child of the game-area div
import { noop } from 'lodash'
import { useEffect, useRef } from 'react'
import './game-over-screen.scss'
import JSConfetti from 'js-confetti'
import soundCheer from '../assets/cheer.mp3'
import SocialShare from './social-share'

const jsConfetti = new JSConfetti()

const GAME_IDS = {
    FLAPPY_BLOCK: 'flappy_games',
    MEMORY_BLOCK: 'memory_games',
    WHACK_A_BLOCK: 'whack_games',
}

class Sounds {
    constructor() {
        this.sounds = {
            cheer: new Audio( soundCheer ),
        }
    }

    play ( name ) {
        this.sounds[ name ].currentTime = 0
        this.sounds[ name ].play()
    }
}
const sounds = new Sounds()

const GameOverScreen = props => {
    const buttonRef = useRef()  

    const isNewHighest = props.playerStats.justBeatHighScore
    const rank = props.rankCheckFunc( props.scores, props.score )
    const gameStats = ( props.stats || {} ).find( stat => {
        return stat.name === GAME_IDS[ props.game ]
    } )
    let statsLabel = ''
    if ( gameStats && gameStats.value ) {
        statsLabel = ` of ${ gameStats.value.toLocaleString() }`
    }

    useEffect( () => {
        const t = setTimeout( () => {
            buttonRef.current.focus()
        }, 1000 )

        let c
        if ( isNewHighest || ( rank && rank < 100 ) ) {
            c = setTimeout(() => {
                sounds.play( 'cheer' )
                jsConfetti.addConfetti({
                    emojis: ['🌈', '🏆', '🥳', '🎉', '😎', '🤘', '🎈', '🍺'],
                    emojiSize: 100,
                    confettiNumber: 50,
                })
            }, 1200 );
        }

        return () => {
            clearTimeout( t )
            clearTimeout( c )
        }
    }, [isNewHighest, rank] )


    return (
        <div className="game-over-screen">
            <h2>Game Over</h2>
            <p className="game-over-screen__score">{ isNewHighest ? 'New High Score' : 'You scored' } { props.score } { isNewHighest ? '😎' : '' }</p>
            { ! isNewHighest && <p className="game-over-screen__best">(Best { props.playerStats.bestScore })</p> }
            <p className="game-over-screen__rank">You Ranked { rank > 500 ? '500+' : (rank ? rank : '-') } { statsLabel } { rank && rank <= 100 ? '🏆' : '' }</p>
            <SocialShare game={ props.game } score={ props.playerStats.bestScore } />
            <button className="game-over-screen__button" ref={ buttonRef } onClick={ props.onRestart } onTouchStart={ props.onRestart } onKeyDown={ props.onRestart }>Play again</button>
        </div>
    )
}

GameOverScreen.defaultProps = {
    score: 0, // Final score
    highest: 0,
    isHighest: false,
    onRestart: () => {}, // Called to play again
    game: 'FLAPPY_BLOCK',
    scores: [], // This contains all the leaderboard entries
    rankCheckFunc: noop, // This function returns the rank of a score
    playerStats: {}, // Player stats (see game-window.js for format)
    stats: {},
}

export default GameOverScreen


